import React from 'react';
import Loader from './Loader';

/**
 * Bulk delete actions component
 * Shows selected count and delete button
 */
const BulkDeleteActions = ({ 
  selectionCount, 
  onDelete, 
  isDeleting, 
  onClear,
  itemName = 'items'
}) => {
  if (selectionCount === 0) return null;

  return (
    <div className="d-flex align-items-center gap-3 p-3 bg-light-primary rounded mb-3">
      <div className="d-flex align-items-center">
        <span className="fw-semibold text-primary me-2">
          {selectionCount} {itemName} selected
        </span>
      </div>
      <div className="d-flex gap-2">
        <button
          type="button"
          className="btn btn-sm btn-light"
          onClick={onClear}
          disabled={isDeleting}
        >
          Clear Selection
        </button>
        <button
          type="button"
          className="btn btn-sm btn-danger"
          onClick={onDelete}
          disabled={isDeleting}
        >
          {isDeleting ? (
            <>
              <Loader size="16" color="white" text="Deleting" />
            </>
          ) : (
            <>
              <i className="bi bi-trash-fill me-1"></i>
              Delete Selected ({selectionCount})
            </>
          )}
        </button>
      </div>
    </div>
  );
};

export default BulkDeleteActions;

